(function () {
  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function removeByKeys(keys, button) {
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        window.location.reload();
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        window.alert('Could not remove bundle. Please try again.');
      });
  }

  document.addEventListener('click', function (event) {
    var babButton = event.target.closest('[data-bab-remove]');
    if (babButton) {
      event.preventDefault();
      var raw = babButton.getAttribute('data-bab-keys') || '';
      removeByKeys(raw.split(',').filter(Boolean), babButton);
      return;
    }

    var sspButton = event.target.closest('[data-ssp-bundle-remove]');
    if (sspButton) {
      event.preventDefault();
      var lineKey = sspButton.getAttribute('data-line-key') || '';
      removeByKeys(lineKey ? [lineKey] : [], sspButton);
    }
  });
})();
